import React, { useCallback, useEffect } from "react"
import { HistoricoPedidosHeaderProps } from "./historico-pedidos-header-props"
import { Box, Divider, IconButton, Typography } from "@material-ui/core"
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useStyles } from "./historico-pedidos-header-styles";
import classNames from "classnames";
import { EnumModals, useModalStore } from "services/store/modal-store";
import { MeusPedidosIcon } from "utils";

export const HistoricoPedidosHeader = ({ voltar, ...props }: HistoricoPedidosHeaderProps) => {

    const classes = useStyles()
    const { openCloseModal } = useModalStore((state) => state)
    const closeModal = useCallback(() => voltar ? voltar() : openCloseModal(EnumModals.HistoricoPedidos, false), [openCloseModal, voltar])

    // Intercept browser back when sacola is aberta and execute the FasesHeader voltar behavior
    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            closeModal()
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [closeModal])

    return (
        <Box className={classes.header}>
            <Box className={classes.container}>
                <IconButton
                    onClick={() => closeModal()}
                    className={classes.iconButton}
                >
                    <ArrowBackIosIcon className={classNames(classes.iconVoltar)} />
                </IconButton>
                <Box display="flex" alignItems="center">
                    <Box className={classes.content}>
                        <MeusPedidosIcon tipo="INPUT" class={classes.icon} />
                    </Box>
                    <Typography
                        className={classes.label}
                    >
                        Histórico de Pedidos
                    </Typography>
                </Box>
            </Box>
            <Divider className={classes.divider} />
        </Box>
    )
}